import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import { findByIdConfiguracaoHorarioAtendimento } from '../../../../services/ConfiguracaoHorarioAtendimentoService';

import Table from '../../../../components/Table/Table';
import { generateTimeList } from '../../../../utils/generateTimeList';
import { convertToObject } from '../utils/convertToObject';
import Scroll from '../../../../components/InfiniteScroll/Scroll';
import { getConvenioTableHeader } from './getConvenioTableHeader';
import ConfigConvenioModal from './ConfigConvenioModal';

const ConvenioTab = ({ classes, configuracaoHorarioAtendimentoId }) => {
  const [currentConfigVigente, setCurrentConfigVigente] = useState(null);
  const [configVigentes, setConfigVigentes] = useState([]);
  const [modalData, setModalData] = useState({ isOpen: false });
  const [horarios, setHorarios] = useState([]);

  const loadConfigVigentes = async () => {
    try {
      const response = await findByIdConfiguracaoHorarioAtendimento({ id: configuracaoHorarioAtendimentoId });
      const { duracao, horaInicioPeriodoAtendimento, horaFimPeriodoAtendimento, horariosAtendimento } = response;
      setCurrentConfigVigente(response);
      const timeList = generateTimeList(horaInicioPeriodoAtendimento, horaFimPeriodoAtendimento, Number(duracao));
      setHorarios(timeList);
      if (timeList?.length > 0) {
        mapHorariosAtendimento(timeList, horariosAtendimento);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const mapHorariosAtendimento = (timeList, horariosAtendimento) => {
    const configByTime = [];
    timeList.forEach(time => {
      const configfiltered = horariosAtendimento.filter(config => config.horaInicio === time);
      configByTime.push({
        ...convertToObject(configfiltered),
        horaInicio: time,
      });
    });
    setConfigVigentes(configByTime);
  };

  const handleCellClick = (item) => {
    setModalData({ ...item, isOpen: true });
  };

  const handleCloseModal = async ({ isReloadingConfig }) => {
    setModalData({ isOpen: false });
    if (isReloadingConfig) await loadConfigVigentes();
  };

  useEffect(() => {
    if (configuracaoHorarioAtendimentoId) loadConfigVigentes();
  }, []);

  return (
    <div className={classes.root}>
      <Scroll>
        <Table
          columns={getConvenioTableHeader({ onClick: handleCellClick })}
          dados={configVigentes || []}
        />
      </Scroll>
      <ConfigConvenioModal
        {...modalData}
        onClose={handleCloseModal}
        horarios={horarios}
        currentConfigVigente={currentConfigVigente}
      />
    </div>
  );
};

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    height: 'calc(100vh - 300px)',
    '&>div>div>div>table>thead>tr': {
      height: '35px',
      '&>th': { padding: '4px 8px', textAlign: 'center' }
    },
    '&>div>div>div>table>tbody>tr': {
      height: '35px',
      '&>td': {
        padding: '4px 8px',
        textAlign: 'center',
        width: '100px',
        '& > div': { display: 'flex', alignItems: 'center', justifyContent: 'center' }
      }
    },
  },
};

export default withStyles(styles)(ConvenioTab);
